
export const truncateStyle = {
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis"
};

export const pointerStyle = {
	cursor: "pointer",
};
